import React from 'react';
import { motion } from 'framer-motion';
import { FaBook, FaClock, FaChartLine } from 'react-icons/fa';

const Courses = () => {
    const courses = [
        {
            subject: 'GCSE Mathematics',
            tutor: 'Mr. Thompson',
            nextSession: 'Tomorrow, 14:00',
            progress: 75,
            topics: ['Algebra', 'Geometry', 'Trigonometry'],
            color: '#2B7A8C'
        },
        {
            subject: 'A-Level Physics',
            tutor: 'Dr. Sarah Wilson',
            nextSession: 'Wednesday, 15:00',
            progress: 60,
            topics: ['Mechanics', 'Waves', 'Electricity'],
            color: '#FFD700'
        },
        {
            subject: 'GCSE Chemistry',
            tutor: 'Ms. Ahmed',
            nextSession: 'Friday, 13:00',
            progress: 85,
            topics: ['Atomic Structure', 'Bonding', 'Reactions'],
            color: '#2B7A8C'
        }
    ];

    return (
        <div>
            <h1 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: 'var(--color-secondary)', marginBottom: '0.5rem' }}>My Courses</h1>
            <p style={{ color: '#666', marginBottom: '2rem' }}>Manage your enrolled subjects</p>

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '1.5rem' }}>
                {courses.map((course, index) => (
                    <motion.div
                        key={course.subject}
                        initial={{ opacity: 0, scale: 0.95 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ delay: index * 0.1 }}
                        style={{
                            background: 'white',
                            padding: '1.5rem',
                            borderRadius: '12px',
                            border: '1px solid #eee',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.02)'
                        }}
                    >
                        <div style={{ display: 'flex', alignItems: 'start', gap: '1rem', marginBottom: '1rem' }}>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '8px',
                                background: course.color === '#2B7A8C' ? 'var(--color-teal-light)' : '#FFF9E6',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <FaBook size={24} color={course.color} />
                            </div>
                            <div style={{ flex: 1 }}>
                                <h3 style={{ fontWeight: '600', marginBottom: '0.25rem' }}>{course.subject}</h3>
                                <div style={{ fontSize: '0.9rem', color: '#666' }}>with {course.tutor}</div>
                            </div>
                        </div>

                        <div style={{ background: '#f8f9fa', padding: '1rem', borderRadius: '8px', marginBottom: '1rem' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                                <FaClock size={14} color="#666" />
                                <div style={{ fontSize: '0.9rem', color: '#666' }}>Next Session</div>
                            </div>
                            <div style={{ fontWeight: '600' }}>{course.nextSession}</div>
                        </div>

                        <div style={{ marginBottom: '1rem' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                                <div style={{ fontSize: '0.9rem', color: '#666', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                                    <FaChartLine size={14} />
                                    Progress
                                </div>
                                <div style={{ fontSize: '0.9rem', fontWeight: '600' }}>{course.progress}%</div>
                            </div>
                            <div style={{ background: '#f0f0f0', height: '8px', borderRadius: '4px', overflow: 'hidden' }}>
                                <div style={{
                                    width: `${course.progress}%`,
                                    height: '100%',
                                    background: course.color,
                                    transition: 'width 1s ease-out'
                                }}></div>
                            </div>
                        </div>

                        <div style={{ marginBottom: '1rem' }}>
                            <div style={{ fontSize: '0.9rem', color: '#666', marginBottom: '0.5rem' }}>Current Topics:</div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                                {course.topics.map(topic => (
                                    <span key={topic} style={{
                                        background: '#f0f0f0',
                                        padding: '0.25rem 0.75rem',
                                        borderRadius: '12px',
                                        fontSize: '0.85rem'
                                    }}>
                                        {topic}
                                    </span>
                                ))}
                            </div>
                        </div>

                        <button className="button-primary" style={{ width: '100%', padding: '0.75rem' }}>
                            Join Session
                        </button>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default Courses;
